import { clickOutside } from '@/plugins/directives/click-outside.js';

const directives = {
  'click-outside': clickOutside
};

export const init = vueInstance => {
  for (const key in directives) {
    vueInstance.directive(key, directives[key]);
  }
};
